import { DotsHorizontalIcon } from './DotsHorizontalIcon';

/**
 * author: Google
 * id 9156AFAA-25BB-4E97-9EC8-BB9BE9AF60B0
 * name dots-horizontal
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dots-horizontal.svg
 * tags
 */
export const MoreHorizIcon = DotsHorizontalIcon;
export default MoreHorizIcon